module.exports = __webpack_public_path__ + "static/media/ic_ccm_plan_selection.cfbe0ca8.png";